import React from 'react';
import Seo from '../components/Seo';
import { Layout, Section, PageTitle } from '../components/layout';
import T from '../components/Translation';
import Image from '../components/Image';
import AdoptComprehensive from '../components/security-operations-platform/AdoptComprehensive';
import { ServiceCards, StatsOverview, SecurityCoverage } from '../components/root';
import CertificationsSecOps from '../components/managed-detection-and-response/CertificationsSecOps';

export default function WhyCertego(props) {
  return (
    <Layout pageProps={props}>
      <PageTitle background="why-certego/bg_mountain.webp" backgroundClassName="bg-certego-lightgray h-full">
        <div className="w-full">
          <T tag="h1" className="font-bold lg:text-5xl lg:mb-12 mb-4 md:mt-8" id="why-certego-title">
            With Certego,
            <br />
            <span className="text-certego-black">you can relax:</span>
            <br />
            your security <br />
            <span className="text-certego-black">is in good hands</span>
          </T>
        </div>
      </PageTitle>
      <Section>
        <div className="text-center mx-auto text-certego-black md:pt-0 pt-16">
          <T tag="h2" id="why-certego-subtitle" className="sub-title font-bold lg:mb-16 mb-6">
            Advanced MDR Services
            <br />
            <span className="text-certego-blue">enhanced by</span> proprietary technology
            <br />
            <span className="text-certego-blue">and</span> elite analysts{' '}
            <span className="text-certego-blue">with years of experience</span>
          </T>
        </div>
      </Section>
      <Section>
        <ServiceCards />
      </Section>
      <Section>
        <ul className="grid gap-y-10 mx-auto lg:max-w-6xl">
          {[
            {
              title: 'Consolidate Security Activities into a Single Platform',
            },
            {
              title: 'Reduce Cybersecurity Complexity',
            },
            {
              title: 'Improve Incident Detection and Response Times',
            },
            {
              title: 'Collaborate with Multi-Certified Senior Professionals',
            },
          ].map(({ title }, i) => (
            <li key={title}>
              <div className="box-gradient-light-to-right p-5">
                <Image img="icons/plus.webp" className="h-6" />
                <div className="lg:px-10 p-5 flex lg:items-center lg:flex-row flex-col lg:gap-16 gap-4">
                  <T
                    tag="h3"
                    id={`benefits${i + 1}-title`}
                    className="font-semibold tracking-tight text-certego-blue lg:min-w-56 lg:text-3xl"
                  >
                    {title}
                  </T>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </Section>
      <Section>
        <div className="grid xl:grid-cols-2 xl:gap-20 gap-4 text-certego-black max-w-7xl mx-auto">
          {[
            {
              title: 'Managed Monitoring and 24/7 Support',
              description:
                'Rely on our team for continuous, real-time security monitoring of your entire infrastructure.',
            },
            {
              title: 'Stay Focused on What Matters',
              description:
                'Reduce Fatigue from False Positives and Focus on the Most Critical, Business-Oriented Operations.',
            },
            {
              title: 'Customized and Modular Protection',
              description:
                'Scale the platform and services according to the specific security requirements of your organization.',
            },
            {
              title: 'Extend Your Expertise',
              description:
                'Expand Your In-House Security Team and conduct deeper analyses with the expertise of Certego professionals.',
            },
          ].map(({ title, description }, i) => (
            <div key={title} className="xl:even:text-end">
              <T tag="h3" id={`support${i + 1}-title`} className="font-bold xl:mb-6">
                {title}
              </T>
              <T tag="p" id={`support${i + 1}-descr`} className="text-certego-blue">
                {description}
              </T>
            </div>
          ))}
        </div>
      </Section>
      <Section>
        <StatsOverview />
      </Section>
      <Section>
        <SecurityCoverage />
      </Section>

      <Section>
        <T
          tag="h3"
          id="why-certego-subtitle2"
          className="font-bold sub-title text-certego-blue! md:mb-24 mb-10 md:w-3/5 mx-auto text-center"
        >
          Maximize Telemetry Data Visibility with Certego&apos;s Proprietary Technology.
        </T>

        <div className="grid xl:grid-cols-2 xl:gap-20 gap-4 text-certego-black max-w-7xl mx-auto">
          {[
            {
              title: 'Reduce False Positives',
              description:
                'We apply our IOCs and BIOCs to detection logic to improve detection rules and notify you only of alerts that represent a real security threat.',
            },
            {
              title: 'Anticipate Attacks',
              description:
                'The Threat Intelligence team actively analyzes cybercriminal behavior on a daily basis to improve and proactively update the detection rules of our sensors.',
            },
            {
              title: 'Get Tailored Defenses for the Italian Market',
              description:
                'I nostri IOC e BIOC sono mirati alle esigenze del mercato italiano per offrirti una soluzione costruita sui bisogni specifici della tua organizzazione.',
            },
            {
              title: 'Access more in-depth insights',
              description:
                'Telemetry data provides a higher level of detail, allowing you to thoroughly understand the causes and impact of each security event, while continuously updating your defenses.',
            },
          ].map(({ title, description }, i) => (
            <div key={title} className="xl:even:text-end">
              <T tag="h3" id={`plus${i + 1}-title`} className="font-bold xl:mb-6">
                {title}
              </T>
              <T tag="p" id={`plus${i + 1}-descr`} className="text-certego-blue">
                {description}
              </T>
            </div>
          ))}
        </div>
      </Section>
      <Section>
        <CertificationsSecOps />
      </Section>
      <Section>
        <AdoptComprehensive />
      </Section>
    </Layout>
  );
}

export function Head(props) {
  return <Seo title={{ id: '', children: '' }} description={{ id: '', children: '' }} allProps={props} />;
}
